import PropTypes from "prop-types";
import React from "react";
import XMLViewer from "react-xml-viewer";

const customTheme = {
  attributeKeyColor: "#B7B7B7",
  attributeValueColor: "#B7B7B7",
  textColor: "#8D8D8D",
  tagColor: "#FF585F",
  overflowBreak: true,
  separatorColor: "#3B86FF",
};

const XmlSection = (props) => {
  const { xml, url, onClick } = props;
  return (
    <div className="nip-home-interaction-env-right">
      <div className="top-section">
        <div className="top-section-left">
          <div className="top-section-left-btn">POST</div>
          <div className="top-section-left-link">{url}</div>
        </div>
        <div className="top-section-right">cURL</div>
      </div>

      <div className="bottom-section">
        {xml === "" ? (
          <span>No Content Available</span>
        ) : (
          <XMLViewer xml={xml} theme={customTheme} indentSize={3} />
        )}
      </div>

      <div className="retry-btn">
        <button
          className="button-retry"
          type="button"
          onClick={onClick}
          data-testid="retry"
        >
          retry
        </button>
      </div>
    </div>
  );
};

XmlSection.propTypes = {
  onClick: PropTypes.func,
  url: PropTypes.string,
  xml: PropTypes.any,
};

export default XmlSection;
